import axios from 'axios';
import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import { ResetPasswordFormData } from './resetPasswordForm';

export function useProfile() {
  const navigate = useNavigate();

  const onChangePassword = useCallback(
    async (data: ResetPasswordFormData) => {
      try {
        await axios.post('/auth/change-password', {
          current_password: data.oldPassword,
          new_password: data.password,
        });

        toast.success('Your password has been updated');

        // After successful password change the server will remove sessions — redirect to sign in
        navigate('/signin');
      } catch (err: any) {
        const message =
          err?.response?.data?.message ||
          err?.message ||
          'Failed to change password';

        toast.error(message);
        // Re-throw in case caller wants to handle it
        throw err;
      }
    },
    [navigate]
  );

  return { onChangePassword } as const;
}
